import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=270a5d8a&scoped=true&"
import script from "./heading.vue?vue&type=script&lang=js&"
export * from "./heading.vue?vue&type=script&lang=js&"
import style0 from "./heading.vue?vue&type=style&index=0&id=270a5d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a5d8a",
  null
  
)

export default component.exports